import { ComplexValue } from 'app/types-shared';
import {
  SubscriberGroupItem, SubscriberGroupItemValidation, ExternalMemberValue
} from './types-store';
import { MergeSubscriberGroupState } from 'app/area/subscriber-groups/shared/merge-subscriber-group/types-store';

export const ACTION = {
  REQUEST_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:REQUEST_SUBSCRIBER_GROUP',
  RECEIVE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:RECEIVE_SUBSCRIBER_GROUP',
  FAIL_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:FAIL_SUBSCRIBER_GROUP',

  REQUEST_SAVE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:REQUEST_SAVE_SUBSCRIBER_GROUP',
  RECEIVE_SAVE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:RECEIVE_SAVE_SUBSCRIBER_GROUP',
  FAIL_SAVE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:FAIL_SAVE_SUBSCRIBER_GROUP',

  UPDATE_ITEM: 'SUBSCRIBER_GROUP_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'SUBSCRIBER_GROUP_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'SUBSCRIBER_GROUP_FORM:COPY_LANGUAGE_TO_ALL',

  CHANGE_LONG_DESCRIPTION: 'SUBSCRIBER_GROUP_FORM: CHANGE_LONG_DESCRIPTION',
  COPY_LONG_DESCRIPTION_TO_ALL: 'SUBSCRIBER_GROUP_FORM:COPY_LONG_DESCRIPTION_TO_ALL',

  REQUEST_LANGUAGE_OPTIONS: 'SUBSCRIBER_GROUP_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'SUBSCRIBER_GROUP_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'SUBSCRIBER_GROUP_FORM:FAIL_LANGUAGE_OPTIONS',

  UPDATE_MERGE_SUBSCRIBER_GROUP: 'SUBSCRIBER_GROUP_FORM:UPDATE_MERGE_SUBSCRIBER_GROUP',
  REQUEST_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_FORM:REQUEST_SUBSCRIBER_GROUP_OPTIONS',
  RECEIVE_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_FORM:RECEIVE_SUBSCRIBER_GROUP_OPTIONS',
  FAIL_SUBSCRIBER_GROUP_OPTIONS: 'SUBSCRIBER_GROUP_FORM:FAIL_SUBSCRIBER_GROUP_OPTIONS',

  REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_FORM:REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE',
  RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_FORM:RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE',
  FAIL_SUBSCRIBER_GROUP_ITEM_DELETE: 'SUBSCRIBER_GROUP_FORM:FAIL_SUBSCRIBER_GROUP_ITEM_DELETE',

  ADD_EXTERNAL_MEMBER: 'SUBSCRIBER_GROUP_FORM:ADD_EXTERNAL_MEMBER',
  UPDATE_EXTERNAL_MEMBER_ITEM: 'SUBSCRIBER_GROUP_FORM:UPDATE_EXTERNAL_MEMBER_ITEM',
  REMOVE_EXTERNAL_MEMBER: 'SUBSCRIBER_GROUP_FORM:REMOVE_EXTERNAL_MEMBER',
  REMOVE_ALL_EXTERNAL_MEMBERS: 'SUBSCRIBER_GROUP_FORM:REMOVE_ALL_EXTERNAL_MEMBERS',
  UPDATE_EXTERNAL_MEMBER_VALIDATION: 'SUBSCRIBER_GROUP_FORM:UPDATE_EXTERNAL_MEMBER_VALIDATION',
  RESET_ALL_EXTERNAL_MEMBER_VALIDATION: 'SUBSCRIBER_GROUP_FORM:RESET_ALL_EXTERNAL_MEMBER_VALIDATION',

  CLEAR_FORM: 'SUBSCRIBER_GROUP_FORM:CLEAR_FORM',
  UPDATE_VALIDATION: 'SUBSCRIBER_GROUP_FORM:UPDATE_VALIDATION',
  RESET_VALIDATION: 'SUBSCRIBER_GROUP_FORM:RESET_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class UpdateMergeSubscriberGroup {
  public type: string = ACTION.UPDATE_MERGE_SUBSCRIBER_GROUP;
  constructor(public mergeSubscriberGroup: MergeSubscriberGroupState) {
  }
}

export class RequestSubscriberGroupOptions {
  public type: string = ACTION.REQUEST_SUBSCRIBER_GROUP_OPTIONS;
}

export class ReceiveSubscriberGroupOptions {
  public type: string = ACTION.RECEIVE_SUBSCRIBER_GROUP_OPTIONS;
  constructor(public values: ComplexValue<number>[]) { }
}

export class FailSubscriberGroupOptions {
  public type: string = ACTION.FAIL_SUBSCRIBER_GROUP_OPTIONS;
}

export class RequestSubscriberGroupItemDelete {
  public type: string = ACTION.REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}

export class ReceiveSubscriberGroupItemDelete {
  public type: string = ACTION.RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}

export class FailSubscriberGroupItemDelete {
  public type: string = ACTION.FAIL_SUBSCRIBER_GROUP_ITEM_DELETE;
  constructor(public id: number) {
  }
}

export class RequestSubscriberGroup {
  public type: string = ACTION.REQUEST_SUBSCRIBER_GROUP;
}

export class ReceiveSubscriberGroup {
  public type: string = ACTION.RECEIVE_SUBSCRIBER_GROUP;
  constructor(
    public item: SubscriberGroupItem
  ) { }
}

export class FailSubscriberGroup {
  public type: string = ACTION.FAIL_SUBSCRIBER_GROUP;
}

export class RequestSaveSubscriberGroup {
  public type: string = ACTION.REQUEST_SAVE_SUBSCRIBER_GROUP;
}

export class ReceiveSaveSubscriberGroup {
  public type: string = ACTION.RECEIVE_SAVE_SUBSCRIBER_GROUP;
}

export class FailSaveSubscriberGroup {
  public type: string = ACTION.FAIL_SAVE_SUBSCRIBER_GROUP;
}

export class UpdateExternalMemberItem {
  public type: string = ACTION.UPDATE_EXTERNAL_MEMBER_ITEM;
  constructor(public externalMemberValue: ExternalMemberValue) { }
}

export class RemoveExternalMember {
  public type: string = ACTION.REMOVE_EXTERNAL_MEMBER;
  constructor(public id: number) {
  }
}

export class RemoveAllExternalMembers {
  public type: string = ACTION.REMOVE_ALL_EXTERNAL_MEMBERS;
}

export class AddExternalMember {
  public type: string = ACTION.ADD_EXTERNAL_MEMBER;
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public id: number, public key?: string) {
  }
}

export class ResetAllExternalMemberValidation {
  public type: string = ACTION.RESET_ALL_EXTERNAL_MEMBER_VALIDATION;
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<SubscriberGroupItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class ChangeLongDescription {
  public type: string = ACTION.CHANGE_LONG_DESCRIPTION;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLongDescriptionToAll {
  public type: string = ACTION.COPY_LONG_DESCRIPTION_TO_ALL;
  constructor(public languageId: number) { }
}
export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: SubscriberGroupItemValidation) { }
}
